import React from 'react';
import { Select, FormControl, InputLabel, OutlinedInput } from '@mui/material';
import './StyledSelect.scss';

const MENU_PROPS = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
    },
};

const StyledSelect = ({ label, labelId, fullWidth = true, disabled, children, ...props }) => {
    if (!label) {
        return (
            <Select
                MenuProps={MENU_PROPS}
                variant="outlined"
                className="ss-select-full-width"
                defaultValue=""
                labelId={labelId}
                disabled={disabled}
                {...props}
            >
                {children}
            </Select>
        );
    }

    return (
        <FormControl fullWidth={fullWidth} disabled={disabled} className="ss-form-control">
            <InputLabel id={labelId} shrink>{label}</InputLabel>
            <Select
                MenuProps={MENU_PROPS}
                defaultValue=""
                labelId={labelId}
                input={<OutlinedInput notched label={label} className="ss-select-full-width" />}
                disabled={disabled}
                {...props}
            >
                {children}
            </Select>
        </FormControl>
    );
};
export default StyledSelect;